import { lazyImport } from '../../../Utils'

export const Tabs = lazyImport(() => import('@mui/material/Tabs'), <div />)